module.exports = __webpack_public_path__ + "img/diamond.40963c4b.png";